import React from 'react'
import Grid from '@material-ui/core/Grid'
import TextField from 'components/TextField'
import FormSection from 'components/FormSection'
import DatePickerField from 'components/DatePickerField'
import MultiFieldsGroup from 'components/MultiFieldsGroup'
import WysiwygEditor from 'components/WysiwygEditor'
import Icon from '@material-ui/core/Icon';
import Typography from '@material-ui/core/Typography';
import InputLabel from '@material-ui/core/InputLabel';
import styled from 'styled-components'

const Employment = ({
  mutators
}) => (
  <FormSection
    className="formSesction"
    sortable
    title={(
      <Typography variant="h6" component="h2">
        Edukacja
      </Typography> 
    )}
    subtitle={(
      <Typography component="p">
        Podaj najważniejsze informacje dotyczące Twojej edukacji (szkoły i szkolenia).
      </Typography>
    )}
  >
    <MultiFieldsGroup
      name='education'
      mutators={mutators}
      label='szkołę'
      fieldToPreview='school'
      className='section'
      renderFieldsGroup={(name, index) => (
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <InputLabel shrink>
            Szkoła
            </InputLabel>
            <TextField
              name={`${name}.school`}
              type="text"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
           <InputLabel shrink>
            Poziom nauczania
            </InputLabel>
            <TextField
              name={`${name}.degree`}
              type="text"
            />
          </Grid>
          <Grid item xs={12} sm={3}>            
            <InputLabel shrink>
            Data rozpoczęcia
            </InputLabel>
            <DatePickerField
              name={`${name}.dateFrom`}
              label="" className="dateInput"
            />
          </Grid>
          <Grid item xs={12} sm={3}>            
            <InputLabel shrink>
            Data zakończenia
            </InputLabel>
            <DatePickerField
              name={`${name}.dateTo`}
              label="" className="dateInput"
            />
          </Grid>
          <Grid item xs={12} sm={6}>            
            <InputLabel shrink>
            Miasto
            </InputLabel>
            <TextField
              name={`${name}.city`}
              type="text"
            />
          </Grid>
          <Grid item xs={12} sm={12}>            
            <InputLabel shrink className="no-margins">
            Dodatkowe informacje
            </InputLabel>
            <WysiwygEditor
              name={`${name}.description`}
              type="text"
              label="Opis"
            />
          </Grid>
        </Grid>
      )}
    />
  </FormSection>
)

export default Employment
      